import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Calendar, Phone } from 'lucide-react';
import { useSiteContent } from '@/hooks/useSiteContent';
import { trackEvent } from '@/lib/analytics';

/**
 * Sticky bottom action bar shown only on mobile. Keeps the primary "book" CTA and
 * a call button always reachable while the visitor scrolls.
 * Hidden on /admin and inside the booking wizard (to avoid redundancy).
 */
export default function StickyCTA() {
  const { content } = useSiteContent();
  const location = useLocation();
  const hidden = location.pathname.startsWith('/admin') || location.pathname.startsWith('/rezervacija');
  if (hidden) return null;

  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-slate-200 px-3 py-2.5 flex gap-2"
      data-testid="sticky-cta">
      <Link
        to="/rezervacija"
        data-testid="sticky-cta-book"
        onClick={() => trackEvent('click_book', { source: 'sticky_cta' })}
        className="btn-primary flex-1 py-3 rounded-full font-semibold inline-flex items-center justify-center gap-2 text-sm"
      >
        <Calendar className="w-4 h-4" /> Zakaži čišćenje
      </Link>
      {content.phone && (
        <a
          href={`tel:${content.phone}`}
          data-testid="sticky-cta-call"
          onClick={() => trackEvent('click_call', { source: 'sticky_cta' })}
          aria-label="Pozovi"
          className="w-12 shrink-0 rounded-full bg-emerald-600 text-white inline-flex items-center justify-center hover:bg-emerald-700 transition"
        >
          <Phone className="w-5 h-5" />
        </a>
      )}
    </div>
  );
}
